var _circle, _line, _line2, _circle2, _line3, _line4, _circle3, _line5, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.86,
    cy: 5.038,
    r: 2.43
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.289,
    y1: 5.038,
    x2: 20.293,
    y2: 5.038
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.707,
    y1: 5.038,
    x2: 5.43,
    y2: 5.038
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.14,
    cy: 12,
    r: 2.43
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.569,
    y1: 12,
    x2: 20.293,
    y2: 12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3.707,
    y1: 12,
    x2: 13.71,
    y2: 12
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.57,
    cy: 18.962,
    r: 2.43
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18.962,
    x2: 20.293,
    y2: 18.962
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 3.707,
    y1: 18.962,
    x2: 7.141,
    y2: 18.962
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.77364c7c0e85c6cc3fb0d245697d70c2.svg";
export { ForwardRef as ReactComponent };